import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Col } from '_zari/core'

import * as SocioService from 'services/socio.service'

const SobreNombresFormGroup = ({ iValue, vIdSocio, iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickGuardar = React.useCallback(() => {
    SocioService.actualizarSobrenombreSocioxId(vIdSocio, iValue)
      .then(({ data }) => {
        __zariContext.snack('success', 'Se ha actualizado el nombre rapido.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [vIdSocio, iValue, __zariContext])

  return (
    <Form.Group>
      <Form.Label text='NOMBRE RAPIDO' htmlFor='input-sobrenombre' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='sobrenombreSocio'>
          {({ field }) => (
            <Form.InputGroup>
              <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-sobrenombre' />
              <Form.InputGroup.Append>
                <Button disabled={fIsSubmitting} onClick={clickGuardar}>
                  Actualizar
                </Button>
              </Form.InputGroup.Append>
            </Form.InputGroup>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SobreNombresFormGroup)
